<template>
  <div v-if="currentMedia">
    <PrevNextBar
      :title="currentMedia.title"
      @prev="$router.go(-1)"
      :prev-button-label="$t('GENERAL.LINK.NAVIGATE_BACK')"
      :hide-next-button="true"
    />
    <div class="container">
      <StudioMediaDetails :media="currentMedia" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import LegalWaiverModal from '@/web/components/shop/LegalWaiverModal';
import StudioMediaDetails from '@/web/components/products/StudioMediaDetails';
import PrevNextBar from '@/web/components/products/PrevNextBar';
import RefreshData from '@/web/mixins/refreshData';
import { getStudioURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'StudioProductFreeMedia',
  mixins: [RefreshData],
  components: {
    StudioMediaDetails,
    PrevNextBar,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('product', ['product']),
    productFreeMedia() {
      return this.product?.free_sample_media;
    },
    currentMedia() {
      if (!this.productFreeMedia) {
        return;
      }
      return this.productFreeMedia.find(
        media => media.id == this.$route.params.media_id
      );
    },
  },
  methods: {
    async loadData() {
      const waiver = await this.$store.dispatch('studio/getWaiverToBeSigned', {
        studioURL: getStudioURL(this.$route),
      });
      if (waiver.id) {
        this.$modal.show(
          LegalWaiverModal,
          { showCloseButton: false, waiver },
          { clickToClose: false, classes: 'vm--inline-modal' }
        );
      }
      const payload = {
        studioURL: getStudioURL(this.$route),
        productId: this.$route.params.product_id,
      };
      try {
        await this.$store.dispatch('product/getProductDetail', payload);
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('STUDIO.NOTIFICATIONS.LOAD_PRODUCT_MEDIA_ERROR'),
          text: `Error: ${error}`,
          duration: -1, // stay ON
        });
      }
    },
  },
  mounted() {
    this.loadData();
  },
  beforeDestroy() {
    this.$modal.hideAll();
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
